"use client";

/**
 * DesktopLinks.tsx
 *
 * Horizontal list of navigation links for large screens.
 * Uses the `pathname` and `activeSection` to highlight the current location.
 */

import React from "react";
import Link from "next/link";

interface NavLink {
  name: string;
  label?: string;
  href: string;
}

interface DesktopLinksProps {
  links: NavLink[];
  pathname: string;
  activeSection: string;
}

const DesktopLinks = ({
  links,
  pathname,
  activeSection,
}: DesktopLinksProps) => {
  return (
    <div className="hidden lg:flex items-center space-x-8 h-full mr-8">
      {links.map((link, index) => {
        // Find if this specific item is the active section or the current page
        // For hash links compare activeSection; for total page links compare pathname
        const sectionId = link.href.startsWith("#") ? link.href.slice(1) : null;
        const isActive = sectionId
          ? activeSection === sectionId
          : pathname === link.href;

        return (
          <Link
            key={`${link.name}-${index}`}
            href={link.href}
            className={`relative flex items-center h-full text-[15px] font-bold font-inter transition-colors tracking-wide ${
              isActive ? "text-[#c59d5f]" : "text-white hover:text-[#c59d5f]"
            }`}
          >
            <span>{link.label || link.name}</span>
            {isActive && (
              <span className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#c59d5f]" />
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default DesktopLinks;
